<template>
  <div>
    <Nav></Nav>
    <b-container fluid="xl">
      <b-row class="mt-3"><b-col><h1>Marketing → Atribución</h1></b-col></b-row>

      <!-- QR por sucursal -->
      <b-card class="mb-3" title="QR de descarga por sucursal">
        <b-table small striped responsive :items="sucursals" :fields="sucFields" :busy="loadingSuc">
          <template #cell(buttons)="data">
            <b-button size="sm" variant="primary" @click="downloadQr(data.item)">Descargar QR</b-button>
            <b-button size="sm" variant="outline-secondary" @click="regenQr(data.item)">Regenerar token</b-button>
          </template>
        </b-table>
      </b-card>

      <!-- Inversión de marketing -->
      <b-card class="mb-3" title="Inversión de marketing">
        <b-row>
          <b-col md="2"><b-form-group label="Fecha"><b-form-input type="date" v-model="spend.spend_date"></b-form-input></b-form-group></b-col>
          <b-col md="2"><b-form-group label="Canal"><b-form-input v-model="spend.channel"></b-form-input></b-form-group></b-col>
          <b-col md="3"><b-form-group label="Campaña"><b-form-input v-model="spend.campaign"></b-form-input></b-form-group></b-col>
          <b-col md="2"><b-form-group label="Monto"><b-form-input type="number" step="0.01" v-model.number="spend.amount"></b-form-input></b-form-group></b-col>
          <b-col md="3"><b-form-group label="Notas"><b-form-input v-model="spend.notes"></b-form-input></b-form-group></b-col>
        </b-row>
        <b-button variant="primary" @click="addSpend">Registrar inversión</b-button>
        <b-table class="mt-2" small striped responsive :items="spends" :fields="spendFields"></b-table>
      </b-card>

      <!-- Metas de venta -->
      <b-card title="Metas de venta">
        <b-row>
          <b-col md="2"><b-form-group label="Sucursal (id)"><b-form-input type="number" v-model.number="goal.sucursal_id"></b-form-input></b-form-group></b-col>
          <b-col md="2"><b-form-group label="Periodo (YYYY-MM)"><b-form-input v-model="goal.period"></b-form-input></b-form-group></b-col>
          <b-col md="2"><b-form-group label="Canal"><b-form-input v-model="goal.channel"></b-form-input></b-form-group></b-col>
          <b-col md="3"><b-form-group label="Meta ($)"><b-form-input type="number" step="0.01" v-model.number="goal.goal_amount"></b-form-input></b-form-group></b-col>
        </b-row>
        <b-button variant="primary" @click="saveGoal">Guardar meta</b-button>
        <b-table class="mt-2" small striped responsive :items="goals" :fields="goalFields">
          <template #cell(buttons)="data">
            <b-button size="sm" variant="outline-danger" @click="deleteGoal(data.item)">Eliminar</b-button>
          </template>
        </b-table>
      </b-card>
    </b-container>
  </div>
</template>

<script>
import Nav from "../../components/Nav.vue";
import marketingService from "../../services/marketingService";
import sucursalService from "../../services/sucursalService";

export default {
  name: "atribucion",
  components: { Nav },
  data() {
    return {
      sucursals: [],
      loadingSuc: false,
      sucFields: [
        { key: "id", label: "ID" },
        { key: "nombre", label: "Sucursal" },
        { key: "region", label: "Región" },
        { key: "buttons", label: "" },
      ],
      spend: { spend_date: "", channel: "", campaign: "", amount: 0, notes: "" },
      spends: [],
      spendFields: [
        { key: "spend_date", label: "Fecha" },
        { key: "channel", label: "Canal" },
        { key: "campaign", label: "Campaña" },
        { key: "amount", label: "Monto" },
        { key: "notes", label: "Notas" },
      ],
      goal: { sucursal_id: null, period: "", channel: "", goal_amount: 0 },
      goals: [],
      goalFields: [
        { key: "period", label: "Periodo" },
        { key: "sucursal_id", label: "Sucursal" },
        { key: "channel", label: "Canal" },
        { key: "goal_amount", label: "Meta" },
        { key: "buttons", label: "" },
      ],
    };
  },
  mounted() {
    this.loadSucursals();
    this.loadSpends();
    this.loadGoals();
  },
  methods: {
    loadSucursals() {
      this.loadingSuc = true;
      sucursalService.getAll()
        .then((res) => { this.sucursals = (res.data || []).map((s) => ({ ...s, region: this.strOf(s.region) })); })
        .catch((err) => this.makeToast("Error", this.errMsg(err), "danger"))
        .finally(() => (this.loadingSuc = false));
    },
    strOf(v) {
      if (v && v.String !== undefined) return v.Valid ? v.String : "";
      return v || "";
    },
    downloadQr(suc) {
      marketingService.qrPng(suc.id).then((res) => {
        const url = URL.createObjectURL(res.data);
        const a = document.createElement("a");
        a.href = url;
        a.download = `qr_sucursal_${suc.id}.png`;
        a.click();
        URL.revokeObjectURL(url);
      }).catch((err) => this.makeToast("Error", this.errMsg(err), "danger"));
    },
    regenQr(suc) {
      marketingService.regenerateQr(suc.id)
        .then((res) => this.makeToast("Listo", "Nuevo QR: " + (res.data.url || ""), "success"))
        .catch((err) => this.makeToast("Error", this.errMsg(err), "danger"));
    },
    loadSpends() {
      marketingService.listSpend({}).then((res) => { this.spends = res.data || []; }).catch(() => {});
    },
    addSpend() {
      marketingService.createSpend(this.spend)
        .then(() => { this.loadSpends(); this.makeToast("Listo", "Inversión registrada", "success"); })
        .catch((err) => this.makeToast("Error", this.errMsg(err), "danger"));
    },
    loadGoals() {
      marketingService.listGoals("").then((res) => { this.goals = res.data || []; }).catch(() => {});
    },
    saveGoal() {
      marketingService.upsertGoal(this.goal)
        .then(() => { this.loadGoals(); this.makeToast("Listo", "Meta guardada", "success"); })
        .catch((err) => this.makeToast("Error", this.errMsg(err), "danger"));
    },
    deleteGoal(g) {
      marketingService.deleteGoal(g.id)
        .then(() => { this.loadGoals(); this.makeToast("Listo", "Meta eliminada", "success"); })
        .catch((err) => this.makeToast("Error", this.errMsg(err), "danger"));
    },
    errMsg(err) {
      if (err && err.response && err.response.data) {
        return typeof err.response.data === "string" ? err.response.data : (err.response.data.error || JSON.stringify(err.response.data));
      }
      return err && err.message ? err.message : "Error desconocido";
    },
    makeToast(title, content, variant) {
      this.$bvToast.toast(content, { title, variant, autoHideDelay: 5000, appendToast: true });
    },
  },
};
</script>
